import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/hooks/useAuth';

export function useWhatsAppGlobalStatus() {
  const { user } = useAuth();
  
  return useQuery({
    queryKey: ['whatsapp-global-status', user?.id],
    queryFn: async () => {
      if (!user?.id) return null;
      
      const { data, error } = await supabase
        .from('user_settings')
        .select('whatsapp_connected, whatsapp_phone')
        .eq('user_id', user.id)
        .maybeSingle();

      if (error) {
        console.error('Error fetching whatsapp status:', error);
        throw error;
      }
      
      return data;
    },
    enabled: !!user?.id,
    refetchInterval: 30000, // Polling a cada 30 segundos
  });
}
